import axios from 'axios'
import { buildQuery } from '../exports/queryStringBuilder'
export default {
    async create(model) {
        return await axios.post(`customer-document`, model)
    },
    async fetchById(id) {
        return await axios.get(`customer-document/${id}`)
    },
    async fetch(query, page) {
        return await axios.get(`customer-document?q=${query}&page=${page}`)
       
    },
    async fetch_data(query,page,filters){
        return await axios.get(`customer-document?q=${query}&page=${page}&${buildQuery(filters)}`)
    },
    async fetchDrivers() {
        return await axios.get(`user`)
    },
  
    async update(id, model) {
        return await axios.put(`customer-document/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`customer-document/${id}`)
    },
    async fetchDocumentType(){
        return await axios.get('customer-document/document-type-list');
    }
}
